export default {
  PdrQuote: {
    name: 'PDR Quote',
    sortOrder: 2
  },
  OtherIndustries: {
    name: 'Other Industries',
    sortOrder: 29
  },
  BookingIn: {
    name: 'Booking-In',
    sortOrder: 8
  },
  Sms: {
    name: 'SMS',
    sortOrder: 9
  },
  Imaging: {
    name: 'Imaging',
    sortOrder: 6
  },
  Accounting: {
    name: 'Accounting',
    sortOrder: 4
  },
  Myob: {
    name: 'MYOB',
    sortOrder: 99
  },
  RepairerQuote: {
    name: 'Repairer Quote',
    sortOrder: 0
  },
  OnlineParts: {
    name: 'Online Parts',
    sortOrder: 5
  },
  MiscQuote: {
    name: 'MISC Quote',
    sortOrder: 1
  },
  MoneyWorks: {
    name: 'MoneyWorks',
    sortOrder: 100
  },
  Management: {
    name: 'Management',
    sortOrder: 7
  },
  TowingQuote: {
    name: 'Towing Quote',
    sortOrder: 2
  },
  FlexiquotePwaAccess: {
    name: 'Flexiquote PWA',
    sortOrder: 0
  }
}